import { Backdrop, CircularProgress } from '@mui/material';
import React from 'react';
const Loading = ({ isDark = false, noOverlay = false }) => {
  return (
    <>
      {!noOverlay ? (
        <Backdrop sx={{ color: 'primary.main', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={true}>
          <div class={`loader-custom loader-custom-${isDark ? 'dark' : 'white'}`}></div>
        </Backdrop>
      ) : (
        <div class={`loader-custom loader-custom-${isDark ? 'dark' : 'white'}`}></div>
      )}
    </>
  );
};

export default Loading;
